import { Typography } from  '@mui/material';
import styled from 'styled-components';

interface Props {
    $colorName?: string;
    $fontWeight?: number | string;
}

const BodyTextSmall = styled(Typography)<Props>`
    font-family: 'Roboto';
    font-style: normal;
    font-weight: ${props => props.$fontWeight || 400};
    font-size: 13px;
    line-height: 15px;
    color: ${props => `var(${props.$colorName || '--black'})`};
    @media only screen and (max-width: 767px) {
      font-size: 13px;
    }
`

export default BodyTextSmall;